import React from 'react'
import EmptyScreen from 'packages/ui/EmptyScreen'
import { useTranslation } from 'react-i18next'

interface LoaderErrorProps {
  i18nkey: string
  children?: React.ReactNode
  iconSize?: string
}

const LoaderError = ({ i18nkey, iconSize = '60px' }: LoaderErrorProps) => {
  const { t } = useTranslation()

  return (
    <EmptyScreen icon="circle-xmark" iconSize={iconSize}>
      {t(i18nkey)}
    </EmptyScreen>
  )
}

export default LoaderError
